var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('div',{staticClass:"w-full flex flex-row justify-center"},[_c('button',{on:{"click":function($event){return _vm.loadMoreByCategory(_vm.category)}}},[_vm._v("load more")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }